import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CircleCross } from 'AppSrc/core/components/common/svg-icons';
import { AlertPortal } from 'AppSrc/core/components/portals/alert-portal';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { groupMemberShape } from 'AppSrc/core/data-structures/api-proptypes';
import { getArraySortedByProperty } from 'AppSrc/core/utility-functions/sort-functions';
import {
  updateEditCrqWithIdAssignApproval,
} from 'AppSrc/core/actions/actions-update-edit-form';
import { ASSIGN_APPROVAL_STATUS } from 'AppSrc/core/approvers/approval-statuses';
import { fetchCrqForViewEdit } from 'AppSrc/core/actions/actions-edit-form';
import { ES_VIEWING_NEW_SECTION } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { SearchBar } from './search-bar';
// import { fetchCrq } from '../../crq/crq-actions';
import 'AppSrc/core/components/forms/select-coordinator/view-crq-select-individual-approver.css';

const AllApproverTableDisplayUnconnected = ({
  groupMembers,
  setCoordinator,
  onClickDisappear,
  isViewOnly,
  isAssign,
  isReAssign,
  approverCall,
  network,
  approvalSignature,
  crqId,
}) => {
  const numResults = groupMembers.length;
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedApprover, setSelectedApprover] = useState('');
  const [ShowClose, SetShowClose] = useState(false);
  const [searchedQuery, ClearSeachecQuery] = useState('');

  const onClickConfirm = (e) => {
    setOpenDialog(!openDialog);
    setSelectedApprover(e);
    return e;
  };

  const onClickYes = () => {
    setOpenDialog(!openDialog);
    onClickDisappear(true);
    const assignedApprover = selectedApprover;
    approverCall(assignedApprover, approvalSignature);
  };

  const onClickNo = () => {
    setOpenDialog(!openDialog);
  };

  const [displayedName, setDisplayedName] = useState(groupMembers);
  useEffect(
    () => {
      setDisplayedName(groupMembers);
    },
    [setDisplayedName, groupMembers],
  );

  const searchHandler = (event) => {
    const searchQuery = event.toLowerCase();
    ClearSeachecQuery(searchQuery);
    if (searchQuery.length !== 0) {
      SetShowClose(true);
    }
    if (searchQuery.length === 0) {
      SetShowClose(false);
    }
    const displayedValue = groupMembers.filter((el) => {
      const searchValue = el.email.toLowerCase().startsWith(searchQuery);
      return searchValue;
    });
    setDisplayedName(displayedValue);
    return true;
  };
  const hideClosebutton = (e) => {
    ClearSeachecQuery('');
    setDisplayedName(groupMembers);
    SetShowClose(false);
    return true;
  };
  const results = displayedName;
  const arrFiltered = results.filter((el) => {
    console.log('test');
    return el.email !== null && el.email !== '';
  });

  const sortedResults = getArraySortedByProperty(arrFiltered, 'email');

  if (!numResults) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="select-coordinator-table-vf-table">
        <div className="vf-table-head-container">
          <div className="vf-table-head">
            <div className="head-item">
              <div className="holder">
                <SearchBar
                  searchHandler={searchHandler}
                  placeholder="Please Search Here"
                  value={searchedQuery}
                />
              </div>
              {
                ShowClose && (
                  <div className="cancle-svg-wrapper">
                    <button type="button" className="clearsearchbutton" onClick={(e) => hideClosebutton('Clear')}>
                      <CircleCross />
                    </button>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <div className="vf-table-body">
          <div className="vf-table-row-container">
            <div className="vf-table-row-member">
              <OptionButton
                className="row-button"
                onClick={(e) => onClickConfirm('None')}
                // disabled={isSelected}
              >
                <div className="row-item">
                  <span className="row-item-text">
                    None
                  </span>
                </div>
              </OptionButton>
            </div>
          </div>
          {
            sortedResults.map((member) => {
              const isSelected = member.id;
              console.log('memberId', isSelected);
              return (
                <div
                  className="vf-table-row-container"
                  key={member.email}
                >
                  <div className="vf-table-row-member">
                    <OptionButton
                      className="row-button"
                      onClick={(e) => onClickConfirm(member.email)}
                      option={member}
                      // disabled={isSelected}
                    >
                      <div className="row-item">
                        <span className="row-item-text">
                          {member.email}
                        </span>
                      </div>
                    </OptionButton>
                  </div>
                </div>
              );
            })
          }
        </div>
        { openDialog && isViewOnly === false && (
          <AlertPortal>
            <div className="alert-section">
              <div className="alert-shadow" />
              <div className="alert-inner">
                <div className="alert-texts">
                  <h1 className="alert-title">
                    Are you sure you want to Assign approver?
                  </h1>
                </div>
                <div className="alert-options alert-options-spacemaker" />
                <div className="alert-options">
                  <div className="side-left">
                    <OptionButton
                      className="false-button"
                      type="button"
                      onClick={onClickNo}
                    >
                      No
                    </OptionButton>
                  </div>
                  <div className="side-right">
                    <OptionButton
                      className="true-button"
                      type="button"
                      onClick={onClickYes}
                    >
                      Yes
                    </OptionButton>
                  </div>
                </div>
              </div>
            </div>
          </AlertPortal>
        )}
      </div>
    </React.Fragment>
  );
};

AllApproverTableDisplayUnconnected.propTypes = {
  groupMembers: PropTypes.arrayOf(groupMemberShape),
  setCoordinator: PropTypes.func,
  onClickDisappear: PropTypes.func,
  network: PropTypes.string,
  crqId: PropTypes.string,
  approverCall: PropTypes.func,
  isViewOnly: PropTypes.bool,
  isAssign: PropTypes.bool,
  isReAssign: PropTypes.bool,
  approvalSignature: PropTypes.string,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  approverCall(assignedApprover, approvalSignature) {
    const {
      network,
      crqId,
    } = ownProps;
    const approvalSigntures = [{
      assignee: assignedApprover === 'None' ? null : assignedApprover,
      crq_id: crqId,
      network,
      reason: '',
      status: ASSIGN_APPROVAL_STATUS,
      signature: approvalSignature,
    }];
    dispatch(updateEditCrqWithIdAssignApproval(approvalSigntures))
      .then(() => {
        dispatch(fetchCrqForViewEdit({
          editingStatus: ES_VIEWING_NEW_SECTION,
          crqId,
          network,
        }));
      });
  },
});

const AllApproverTableDisplay = connect(
  null,
  mapDispatchToProps,
)(AllApproverTableDisplayUnconnected);

export {
  AllApproverTableDisplay,
};
